import React, { useState } from 'react';

import IconButton from '@material-ui/core/IconButton';
import Menu       from '@material-ui/core/Menu';
import MenuItem   from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';

import ListItemIcon    from '@material-ui/core/ListItemIcon';
import MoreVertIcon    from '@material-ui/icons/MoreVert';
import PersonAddIcon from '@material-ui/icons/PersonAdd';

import { create } from '../util';

export default function AttenderMenu(props) {
  const [ anchorEl, setAnchorEl ] = useState(null);

  const { setNewAttender, setPath } = props.context.getStates();

  return (<>
    <IconButton color="inherit"
      onClick={(event => { setAnchorEl(event.currentTarget); })}
    ><MoreVertIcon /></IconButton>

    <Menu anchorEl={anchorEl} open={Boolean(anchorEl)}
      keepMounted
      onClose={(event) => { setAnchorEl(null); }}
    >
      <MenuItem onClick={(event) => {
        setNewAttender(create.attender(-1));
        setPath('/attenders#new-attender');
        setAnchorEl(null);
      }}>
        <ListItemIcon>
          <PersonAddIcon />
        </ListItemIcon>
        <Typography variant="inherit">{'새 참가자 등록'}</Typography>
      </MenuItem>
    </Menu>
  </>);
}